import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/redux";
interface IToast{
  title?:string;
  description?:string
  type?:string
}
// Define the shape of our context value

interface AppContextType {
  rights: {isView: number; isEdit: number}|undefined;
    setRights: React.Dispatch<React.SetStateAction<{isView: number; isEdit: number}>>;
  isSideBar: boolean;
  setIsSideBar: React.Dispatch<React.SetStateAction<boolean>>;
  setShowToast:React.Dispatch<React.SetStateAction<IToast|boolean>>;
  showToast:IToast|boolean;
}

// Create the context with an initial value of undefined
const AppContext = createContext<AppContextType | undefined>(undefined);

// Provider component type
interface AppProviderProps {
  children: ReactNode;
}


// Provider component
export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
   const [rights, setRights] = useState<{isView: number; isEdit: number}>({
        isView: 0,
        isEdit: 0
    });
  const [isSideBar, setIsSideBar] = useState<boolean>(false);
  const [showToast , setShowToast]= useState<IToast|boolean>(false)
  const {theme} = useSelector((state:RootState)=> state.user)
  useEffect(() => {
    if (theme=="dark") {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    
  }, [theme]);

  return (
    <AppContext.Provider value={{rights, setRights, isSideBar, setIsSideBar  , setShowToast , showToast }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for accessing the context
export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};
